import Button from "./common/Button";
import Card from "./common/Card";
import SectionTitle from "./common/SectionTitle";

const services = [
	{
		icon: "fas fa-code",
		title: "Custom Software Development",
		description:
			"Tailored software solutions designed to meet your specific business requirements.",
	},
	{
		icon: "fas fa-cloud",
		title: "Cloud Services",
		description:
			"Comprehensive cloud solutions including migration, management, and optimization.",
	},
	{
		icon: "fas fa-shield-alt",
		title: "Cybersecurity",
		description:
			"Protect your business with our advanced security solutions and consulting.",
	},
	{
		icon: "fas fa-mobile-alt",
		title: "Mobile App Development",
		description:
			"Cross-platform mobile applications for iOS and Android devices.",
	},
	{
		icon: "fas fa-chart-line",
		title: "Data Analytics",
		description:
			"Turn your data into actionable insights with our analytics solutions.",
	},
	{
		icon: "fas fa-robot",
		title: "AI & Machine Learning",
		description:
			"Leverage artificial intelligence to automate and optimize your processes.",
	},
];

const Services = ({ limit, titleHead = false }) => {
	const displayedServices = limit ? services.slice(0, limit) : services;

	return (
		<section className="services">
			<div className="containerr flex flex-col px-5 items-center">
				{titleHead && (
					<SectionTitle
						title="Our Services"
						subtitle="Comprehensive IT solutions tailored to your needs"
					/>
				)}

				<div className="services-grid w-full">
					{displayedServices.map((service, index) => (
						<Card key={index}>
							<div className="service-icon">
								<i className={service.icon}></i>
							</div>
							<h3>{service.title}</h3>
							<p>{service.description}</p>
							<a href="/services" className="learn-more">
								Learn more <i className="fas fa-arrow-right"></i>
							</a>
						</Card>
					))}
				</div>

				{limit && (
					<div className="view-all">
						<Button to="/services" variant="primary">
							View All Services
						</Button>
					</div>
				)}
			</div>
		</section>
	);
};

export default Services;
